import { FC } from 'react';
import { Form } from 'antd';
import { RangePickerProps } from 'antd/lib/date-picker';

import { PICKER_DATE_MASK } from 'shared/constants';
import DateRangePickerWithDots from 'shared/components/dateRangePickerWithDots/DateRangePickerWithDots';
import style from './index..module.scss';

type TProps = {
  disabled: boolean;
  setRange: React.Dispatch<React.SetStateAction<string[] | null>>;
  onChangeRange: () => void;
};

const RangeInput: FC<TProps> = ({ disabled, setRange, onChangeRange }) => {
  const onChangeDate = (_: RangePickerProps['value'], dateString: [string, string] | string) => {
    const from = dateString[0];
    const to = dateString[1];

    if (from === '' && to === '') {
      setRange(null);
      onChangeRange();
    } else {
      setRange([from, to]);
      onChangeRange();
    }
  };

  return (
    <Form.Item label="Период" name="period">
      <DateRangePickerWithDots
        className={style.rangeInput}
        format={PICKER_DATE_MASK}
        onChange={onChangeDate}
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default RangeInput;
